











import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component
export default class LetterTab extends Vue {
    @Prop({ type: String, default: "" })
    letter?: string;

    @Prop({ type: Boolean })
    isChargeTop?: boolean;

    @Prop({ type: String, default: "" })
    isTop?: string;

    top: string = "119px"
    letterTabList: string[] = [
        "所有",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
    ];
    activeIndex: number = 0;

    mounted(){
        if(this.isTop){
            this.top = this.isTop
        }
    }
    letterClick(letter: string, index: number) {
        this.activeIndex = index;
        let key = letter === "所有" ? "" : letter;
        this.$emit("update:letter", key);
        this.$emit("change");
    }
}
